export default {
    AGUARDANDO_RECEBIMENTO: 'Aguardando recebimento',
    EM_ELABORACAO: 'Em elaboração',
    FINALIZADO: 'Finalizado',
    REJEITADO: 'Rejeitado'
}
